import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { getDoc, doc, deleteDoc } from "firebase/firestore"; // Import deleteDoc
import { db } from "../../../firebase";
import { useLocation } from "react-router-dom";
import { format } from "date-fns"; // Import date-fns for date formatting

const Fullview = () => {
  const [message, setMessage] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const messageId = params.get("uid");
    if (messageId) {
      fetchMessage(messageId);
    }
  }, [location.search]);

  const fetchMessage = async (messageId) => {
    try {
      const docRef = doc(db, "notification", messageId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const messageData = docSnap.data();
        // Convert createdAt string to Date object
        messageData.createdAt = new Date(messageData.createdAt);
        setMessage(messageData);
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching message:", error);
    }
  };

  const formatTimestamp = (timestamp) => {
    try {
      const date = new Date(timestamp);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };
      return date.toLocaleDateString("en-US", options);
    } catch (error) {
      console.error("Error formatting timestamp:", error);
      return "Invalid Date";
    }
  };

  // Delete message function
  const handleDelete = async () => {
    try {
      const messageId = message.id; // Assuming message has id field
      await deleteDoc(doc(db, "notification", messageId));
      setAlertSeverity("success");
      setAlertMessage("Message deleted successfully!");
      // Optionally redirect or clear the state after deletion
    } catch (error) {
      console.error("Error deleting message:", error);
      setAlertSeverity("error");
      setAlertMessage(`Error: ${error.message}`);
    } finally {
      setShowAlert(true);
    }
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return (
    <div className="App">
      <main style={{ padding: "20px 5px" }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Avatar
              alt={message.userName || "User"}
              src={message.userImage || "/placeholder.jpg"}
              style={{
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 20,
              }}
            />
            <Card style={{ margin: "0 auto" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  color="#272727"
                  align="center"
                  gutterBottom
                >
                  Message Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="ID"
                      name="id"
                      value={message.id || ""}
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Description"
                      name="message"
                      value={message.message || ""}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Title"
                      name="title"
                      value={message.title || ""}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Timestamp"
                      name="timestamp"
                      value={
                        message.timestamp ? formatTimestamp(message.timestamp) : ""
                      }
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid container justifyContent="center" style={{ marginTop: 16 }}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleDelete}
                    >
                      Delete Message
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Snackbar
              open={showAlert}
              autoHideDuration={6000}
              onClose={handleAlertClose}
            >
              <Alert
                onClose={handleAlertClose}
                severity={alertSeverity}
                sx={{ width: "100%" }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default Fullview;
